import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "adapt-call-to-action-title",
    template: `
        <h2 class="my-3">
          @if (iconClass) {
            <i
            [ngClass]="iconClass"></i>
          }
          <ng-content></ng-content>
        </h2>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CallToActionTitleComponent {
    @Input() public iconClass?: string;
}
